import axios from 'axios';
import config from 'config.js';

// Constants
const CLEAR_FORMS = 'forms/CLEAR_FORMS';
const CLEAR_FORM = 'forms/CLEAR_FORM';

const GET_FORMS_REQUEST = 'forms/GET_FORMS_REQUEST';
const GET_FORMS_SUCCESS = 'forms/GET_FORMS_SUCCESS';
const GET_FORMS_FAILURE = 'forms/GET_FORMS_FAILURE';

const GET_FORM_REQUEST = 'forms/GET_FORM_REQUEST';
const GET_FORM_SUCCESS = 'forms/GET_FORM_SUCCESS';
const GET_FORM_FAILURE = 'forms/GET_FORM_FAILURE';

const DELETE_FORM_REQUEST = 'forms/DELETE_FORM_REQUEST';
const DELETE_FORM_SUCCESS = 'forms/DELETE_FORM_SUCCESS';
const DELETE_FORM_FAILURE = 'forms/DELETE_FORM_FAILURE';

const UNDELETE_ALL_FORM_SUBMISSIONS_REQUEST = 'forms/UNDELETE_ALL_FORM_SUBMISSIONS_REQUEST';
const UNDELETE_ALL_FORM_SUBMISSIONS_SUCCESS = 'forms/UNDELETE_ALL_FORM_SUBMISSIONS_SUCCESS';
const UNDELETE_ALL_FORM_SUBMISSIONS_FAILURE = 'forms/UNDELETE_ALL_FORM_SUBMISSIONS_FAILURE';

const COPY_TO_QS_ACCOUNT_REQUEST = 'forms/COPY_TO_QS_ACCOUNT_REQUEST';
const COPY_TO_QS_ACCOUNT_SUCCESS = 'forms/COPY_TO_QS_ACCOUNT_SUCCESS';
const COPY_TO_QS_ACCOUNT_FAILURE = 'forms/COPY_TO_QS_ACCOUNT_FAILURE';

const getEndpointStatus = (type) => {
  const types = {
    request: {
      loading: true,
      error: false,
      success: false
    },
    success: {
      loading: false,
      error: false,
      success: true
    },
    failure: {
      loading: false,
      error: true,
      success: false
    },
  };

  return types[type];
};

const endpoitInitialStatus = {
  loading: false,
  error: false,
  success: false
};

// Initiual State
const initialState = {
  forms: null,
  form: null,

  getForms: { ...endpoitInitialStatus },
  getForm: { ...endpoitInitialStatus },
  deleteForm: { ...endpoitInitialStatus },
  undeleteAllFormSubmissions: { ...endpoitInitialStatus },
  copyToQsAccount: { ...endpoitInitialStatus }
};

// Reducer
export default function reducer(state = JSON.parse(JSON.stringify(initialState)), action = {}) {
  if (action.type === CLEAR_FORMS) {
    state.forms = null;

    return { ...state };
  }

  if (action.type === CLEAR_FORM) {
    state.form = null;

    return { ...state };
  }

  if (action.type === GET_FORMS_REQUEST) {
    state.getForms = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === GET_FORMS_SUCCESS) {
    state.getForms = getEndpointStatus('success');
    state.forms = action.payload;

    return { ...state };
  }

  if (action.type === GET_FORMS_FAILURE) {
    state.getForms = getEndpointStatus('failure');

    return { ...state };
  }

  if (action.type === GET_FORM_REQUEST) {
    state.getForm = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === GET_FORM_SUCCESS) {
    state.getForm = getEndpointStatus('success');
    state.form = action.payload;

    return { ...state };
  }

  if (action.type === GET_FORM_FAILURE) {
    state.getForm = getEndpointStatus('failure');

    return { ...state };
  }

  if (action.type === DELETE_FORM_REQUEST) {
    state.deleteForm = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === DELETE_FORM_SUCCESS) {
    state.deleteForm = getEndpointStatus('success');

    return { ...state };
  }

  if (action.type === DELETE_FORM_FAILURE) {
    state.deleteForm = getEndpointStatus('failure');

    return { ...state };
  }

  if (action.type === UNDELETE_ALL_FORM_SUBMISSIONS_REQUEST) {
    state.undeleteAllFormSubmissions = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === UNDELETE_ALL_FORM_SUBMISSIONS_SUCCESS) {
    state.undeleteAllFormSubmissions = getEndpointStatus('success');

    return { ...state };
  }

  if (action.type === UNDELETE_ALL_FORM_SUBMISSIONS_FAILURE) {
    state.undeleteAllFormSubmissions = getEndpointStatus('failure');

    return { ...state };
  }

  if (action.type === COPY_TO_QS_ACCOUNT_REQUEST) {
    state.copyToQsAccount = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === COPY_TO_QS_ACCOUNT_SUCCESS) {
    state.copyToQsAccount = getEndpointStatus('success');

    return { ...state };
  }

  if (action.type === COPY_TO_QS_ACCOUNT_FAILURE) {
    state.copyToQsAccount = getEndpointStatus('failure');

    return { ...state };
  }

  return state;
}

// Action Creators
export function clearForms() {
  return (dispatch) => {
    dispatch({ type: CLEAR_FORMS });
  };
}

export function clearForm() {
  return (dispatch) => {
    dispatch({ type: CLEAR_FORM });
  };
}

export function getForms(params) {
  const request = () => { return { type: GET_FORMS_REQUEST } };
  const success = (res) => { return { type: GET_FORMS_SUCCESS, payload: res } };
  const failure = () => { return { type: GET_FORMS_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.getForms(params);

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

export function getForm(id) {
  const request = () => { return { type: GET_FORM_REQUEST } };
  const success = (res) => { return { type: GET_FORM_SUCCESS, payload: res } };
  const failure = () => { return { type: GET_FORM_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.getForm(id);

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

export function undeleteAllFormSubmissions(id) {
  const request = () => { return { type: UNDELETE_ALL_FORM_SUBMISSIONS_REQUEST } };
  const success = (res) => { return { type: UNDELETE_ALL_FORM_SUBMISSIONS_SUCCESS, payload: res } };
  const failure = () => { return { type: UNDELETE_ALL_FORM_SUBMISSIONS_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.undeleteAllFormSubmissions(id);

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

export function copyToQsAccount(id) {
  const request = () => { return { type: COPY_TO_QS_ACCOUNT_REQUEST } };
  const success = (res) => { return { type: COPY_TO_QS_ACCOUNT_SUCCESS, payload: res } };
  const failure = () => { return { type: COPY_TO_QS_ACCOUNT_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.copyToQsAccount(id);

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

export function deleteForm(id) {
  const request = () => { return { type: DELETE_FORM_REQUEST } };
  const success = (res) => { return { type: DELETE_FORM_SUCCESS, payload: res } };
  const failure = () => { return { type: DELETE_FORM_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.deleteForm(id);

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

const services = {
  getForms: async (params) => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${config.apiUrl}/api/admin/forms`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('user_token')}`
        },
        params
      });

      return response;
    } catch (e) {
      return e.response;
    }
  },
  getForm: async (id) => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${config.apiUrl}/api/admin/forms/${id}`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('user_token')}`
        }
      });

      return response;
    } catch (e) {
      return e.response;
    }
  },
  undeleteAllFormSubmissions: async (id) => {
    try {
      const response = await axios({
        method: 'POST',
        url: `${config.apiUrl}/api/admin/forms/${id}/submissions/undo`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('user_token')}`
        }
      });

      return response;
    } catch (e) {
      return e.response;
    }
  },
  deleteForm: async (id) => {
    try {
      const response = await axios({
        method: 'DELETE',
        url: `${config.apiUrl}/api/admin/forms/${id}`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('user_token')}`
        }
      });

      return response;
    } catch (e) {
      return e.response;
    }
  },
  copyToQsAccount: async (id) => {
    try {
      const response = await axios({
        method: 'POST',
        url: `${config.apiUrl}/api/admin/forms/${id}/copy`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('user_token')}`
        }
      });

      return response;
    } catch (e) {
      return e.response;
    }
  }
};
